import { Component } from '@angular/core';

@Component({
  selector: 'pc-linkedin-logo',
  standalone: true,
  imports: [],
  templateUrl: './linkedin-logo.component.html',
  styleUrl: './linkedin-logo.component.scss'
})
export class LinkedinLogoComponent {

}
